
import { computed, defineComponent, inject, onMounted } from 'vue'
import BaseInputText from '@/core/components/base/BaseInputText.vue'
import BaseSelect from '@/core/components/base/BaseSelect.vue'
import InterfaceFilterCompaniesData from '@/assets/ts/_utils/models/FilterCompaniesData'

export default defineComponent({
  name: 'companies-filter',
  components: {
    BaseSelect,
    BaseInputText,
  },
  props: {
    pagesTotal: {
      default: 0,
      type: Number,
      required: true,
    },
    itemsTotal: {
      default: 0,
      type: Number,
      required: true,
    },
  },
  setup(props, context) {
    const companiesFilterData = inject(
      'companiesFilterData'
    ) as InterfaceFilterCompaniesData

    const filterCompaniesButtonClick = () => {
      context.emit('filterCompaniesButtonClick', true)
    }

    const resetFilterForm = () => {
      for (const item in companiesFilterData) {
        if (item !== 'page' && item !== 'limit') {
          companiesFilterData[item] = null
        }
      }
      context.emit('filterCompaniesButtonClick')
    }

    const showPagination = computed(() => {
      return props.pagesTotal > 1
    })

    const paginationClick = val => {
      companiesFilterData.page = val
      context.emit('filterCompaniesButtonClick')
    }

    const parseParamsFromUrl = () => {
      const searchString = window.location.search.replace('?', '')
      const urlSearchParams = new URLSearchParams(searchString)
      return Array.from(urlSearchParams)
    }

    const setDefaultFilterData = () => {
      companiesFilterData.page = 1
      companiesFilterData.limit = 10
      companiesFilterData['filter[status]'] = 'not_verified'
    }

    const convertParamsFromURLArrayToObject = array => {
      array.forEach(([key, value]) => {
        if (key === 'filter[rubric_id]') {
          companiesFilterData[key] = value.split(',').map(Number)
        } else if (key === 'filter[user_id]' || key === 'filter[id]') {
          companiesFilterData[key] = value.split(',')
        } else {
          if (value === 'true') {
            companiesFilterData[key] = true
          } else {
            companiesFilterData[key] = value
          }
        }
      })
    }

    onMounted(async () => {
      const parsedURLArray = parseParamsFromUrl()
      if (parsedURLArray.length) {
        convertParamsFromURLArrayToObject(parsedURLArray)
      } else {
        setDefaultFilterData()
      }
      context.emit('filterCompaniesButtonClick')
    })

    return {
      showPagination,
      paginationClick,
      companiesFilterData,
      filterCompaniesButtonClick,
      parseParamsFromUrl,
      resetFilterForm,
    }
  },
})
